import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  isAuthCallbackUrl,
  peekAuthReturnUrl,
} from '../shared/services/token.util';

@Component({
    selector: 'app-fourzerofour',
    templateUrl: './fourzerofour.component.html',
    styleUrls: ['./fourzerofour.component.scss'],
    standalone: false
})
export class FourzerofourComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService
  ) {}

  ngOnInit() {
    const pendingReturn = peekAuthReturnUrl();
    if (
      pendingReturn &&
      pendingReturn !== '/' &&
      !pendingReturn.includes('fourzerofour') &&
      !isAuthCallbackUrl()
    ) {
      this.auth.isAuthenticated$
        .pipe(
          filter((authenticated) => authenticated),
          take(1)
        )
        .subscribe(() => {
          void this.router.navigateByUrl(pendingReturn, { replaceUrl: true });
        });
    }
  }

  redirect() {
    window.location.href = `${environment.griha_url}/${environment.backRedirection.admin}`;
  }
}
